import { GetSellOrders } from './getSellOrders'
import {DEFAULT_PAGE} from "../../contstants";
import getDateRange from "../../utils/getDateRange";

const FilterSellOrders = async (perPage, filters, isSearchbyprn = false) => {
    const page = filters.page || DEFAULT_PAGE;
    const type = isSearchbyprn ? "" : 'regular';
    const searchInFields = filters.search_in_fields || '';
    const searchPhrase = filters.s;
    const user = searchInFields.includes('user') ? searchPhrase : '';
    const id = searchInFields.includes('id') ? searchPhrase : '';
    const office_id = filters.office_id;
    const prn = filters?.prn ?? "";
    const payment_type = filters.payment_type ?? "";
    const corporate_customer_id = filters.corporate_customer_id ?? "";

    const { dateFrom, dateTo } = getDateRange(filters.date);

    return await GetSellOrders({
        // The row actions need to know whether an order carries cards and
        // specialty items. The export path asks for every order (perPage -1) and
        // only reads ids, so it stays lean.
        details: perPage !== -1,
        limit: perPage,
        offset: (page - 1) * perPage,
        type,
        office_id,
        dateFrom,
        dateTo,
        id,
        user,
        prn,
        payment_type,
        corporate_customer_id
    });
};

export default FilterSellOrders;
